import React from "react";
import { useTranslation } from "react-i18next";
import { LabelColumn, Row, ValueColumn } from "src/components/shared/Sidebar/SidebarTable";
import { localizeCurrencyToWholeNumber } from "src/utils";
import { AccountDisclaimers } from "Types/api/AccountDisclaimers";

interface Props {
    accountDisclaimers?: AccountDisclaimers;
    downPayment: number;
    paymentType: string;
}

const DownPayment = ({ accountDisclaimers, downPayment, paymentType }: Props) => {
    const { t } = useTranslation();

    if (paymentType === "cash") {
        return null;
    }

    return (
        <Row>
            <LabelColumn>
                {(paymentType === "lease"
                    ? accountDisclaimers?.down_payment_label_lease
                    : accountDisclaimers?.down_payment_label_loan) ??
                    t(`ContinueDeal.VehicleInfo.${paymentType === "lease" ? "lease" : "others"}DownPaymentLabel`)}
            </LabelColumn>
            <ValueColumn>{localizeCurrencyToWholeNumber(downPayment)}</ValueColumn>
        </Row>
    );
};

export default DownPayment;
